import React from 'react'
import StripeCheckout from 'react-stripe-checkout';
import Logo from './VERFID_BLUE_PAW_WITH_TM_2.PNG';
import { database } from './utils/firebase';
import { Button } from 'reactstrap';

export default class TakeMoney extends React.Component {
  constructor() {
    super()

    this.state = {
      showSubmitButton: false,
    }
  }
  componentDidMount() {
    this.setUserID();
  }
  setUserID() {
    this.setState({
      userId: this.props.userId,
    })
  }
  onToken = (token) => {
    token = Object.assign(token, { amount: this.props.amount })
    database.ref(`/payments/${this.state.userId}`).push(token).then(() => this.props.onSuccess());
  }
  // ...

  render() {
    return (
      // ...
      <StripeCheckout
        name="VERFID" // the pop-in header title
        description={this.props.description} // the pop-in header subtitle
        image={Logo} // the pop-in header image (default none)
        ComponentClass="div"
        // panelLabel="Give Money" // prepended to the amount in the bottom pay button
        amount={this.props.amount} // cents
        //amount={3600}
        currency="USD"
        stripeKey="pk_live_UwIs0hdEkub5YFmKJt8cVgyh"
        locale="en"
        email={this.props.email}
        receipt_email = {this.props.email}
        // Note: Enabling either address option will give the user the ability to
        // fill out both. Addresses are sent as a second parameter in the token callback.
        shippingAddress
        billingAddress
        // Note: enabling both zipCode checks and billing or shipping address will
        // cause zipCheck to be pulled from billing address (set to shipping if none provided).
        zipCode={false}
        // alipay // accept Alipay (default false)
        // bitcoin // accept Bitcoins (default false)
        allowRememberMe={false} // "Remember Me" option (default true)
        token={this.onToken} // submit callback
        opened={this.onOpened} // called when the checkout popin is opened (no IE6/7)
        closed={this.onClosed} // called when the checkout popin is closed (no IE6/7)
        // Note: `reconfigureOnUpdate` should be set to true IFF, for some reason
        // you are using multiple stripe keys
        reconfigureOnUpdate={false}
        // Note: you can change the event to `onTouchTap`, `onClick`, `onTouchStart`
        // useful if you're using React-Tap-Event-Plugin
        triggerEvent="onClick"
  />
    )
  }
}



// WEBPACK FOOTER //
// ./src/checkout.js